import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    huntingWords: null,
    hasChanges: false,
  },
  mutations: {
    setHuntingWords(state, huntingWords) {
      state.huntingWords = huntingWords;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setHuntingWords({ commit }, model) {
      commit('setHuntingWords', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getHuntingWords({ commit }, id) {
      PuzzleService.getPuzlleById(id)
        .then(response => {
          commit('setHuntingWords', response);
        });
    },
  },
};
